import { ApiStatus, WaterAccountType } from '@types';

import { WaterAccountItem } from '../waterAccountItem/WaterAccountItem';

import styles from './waterAccountList.module.scss';

export interface WaterAccountItemsListProps {
	waterAccounts: WaterAccountType[] | undefined;
	onItemClick: (waterAccount: WaterAccountType) => void;
	selectedWaterAccountId: string;
	loadingWaterAccountStatus?: ApiStatus;
}

export const WaterAccountList = ({
	waterAccounts,
	onItemClick,
	selectedWaterAccountId,
}: WaterAccountItemsListProps) => {
	return (
		<div className={styles.wrapper} data-testid="waterAccountsList">
			<div className={styles[`water-account-list`]}>
				<table aria-label="water account list">
					<thead>
						<tr
							className={styles[`water-account-list-header`]}
							aria-label="water accounts list - header"
							data-testid="tableHeader"
						>
							<th>Name </th>
							<th>Water account reference </th>
							<th>Management group </th>
							<th>Management subgroup </th>
							<th> </th>
						</tr>
					</thead>
					<tbody data-testid="waterAccountsTableBody">
						{waterAccounts &&
							waterAccounts.map(waterAccount => (
								<WaterAccountItem
									waterAccount={waterAccount}
									key={waterAccount.wateraccountId}
									onItemClick={onItemClick}
									selected={selectedWaterAccountId === waterAccount.wateraccountId}
								/>
							))}
					</tbody>
				</table>
			</div>
		</div>
	);
};
